module.exports = __webpack_public_path__ + "static/cafe4-e3a1d84836f572b262c99bfe9bb5f907.jpg";